import React, { Fragment, memo } from 'react'
import tw from 'twin.macro'
import { Button } from 'src/components/shared/Button'
import { CommonModal } from 'src/components/shared/CommonModal'
import type { CustomerProductName } from 'src/constants/customer/enums'
import type { CustomerProduct } from 'src/interfaces/customerProduct'
import { CustomerProductForm } from './CustomerProductForm'
import type {
  CustomerProductFormMode,
  CustomerProductFormValues,
} from './CustomerProductForm.interface'

const FORM_ID = 'customer-product-form'

interface Props {
  isOpen: boolean
  mode: CustomerProductFormMode
  product: CustomerProduct | null
  availableProducts: CustomerProductName[]
  isSaving: boolean
  onSubmit(values: CustomerProductFormValues): void
  onClose(): void
}

const CustomerProductFormModalComponent = ({
  isOpen,
  mode,
  product,
  availableProducts,
  isSaving,
  onSubmit,
  onClose,
}: Props) => {
  return (
    <CommonModal
      isOpen={isOpen}
      title={mode === 'edit' ? 'Edit product' : 'Add product'}
      // Wider than the default confirm-dialog width: this modal carries a form.
      className={tw`max-w-[520px]`}
      onClose={onClose}
      buttons={
        <Fragment>
          <Button size="small" color="grey" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="small"
            color="dark"
            type="submit"
            form={FORM_ID}
            loading={isSaving}
            disabled={isSaving}
            data-testid="customer-product-form-submit-button"
          >
            {mode === 'edit' ? 'Save changes' : 'Add product'}
          </Button>
        </Fragment>
      }
    >
      <CustomerProductForm
        formId={FORM_ID}
        mode={mode}
        product={product}
        availableProducts={availableProducts}
        onSubmit={onSubmit}
      />
    </CommonModal>
  )
}

export const CustomerProductFormModal = memo(CustomerProductFormModalComponent)
